<div class="flex flex-row justify-center">
  <h4 class="text-lg font-bold">{{'#PORTAL_REGISTRATION.CONFIRM.TITLE' | translate}}</h4>
</div>
<div class="flex flex-row">
  <span class="soft-label left">{{'#PORTAL_REGISTRATION.CONFIRM.USERNAME' | translate}}</span>
  <span>{{username}}</span>
</div>
@if (confirming$ | async) {
  <soft-loading-spinner></soft-loading-spinner>
}
<div class="mt-2"></div>
